<div class="flex flex-col">
    <img class="icon" [src]="image" />
    <div class="flex">
        @if (title) {
            <div class="body-copy">
                <span [innerHTML]="title | translate"></span>
                @if (title2 && tooltip) {
                    <app-tooltip [text]="tooltip | translate" [inline]="true"></app-tooltip>
                    <span [innerHTML]="title2 | translate"></span>
                }
            </div>
        }
        @if (tooltip && !title2) {
            <app-tooltip [text]="tooltip | translate"></app-tooltip>
        }
    </div>
    @if (subTitle) {
        <div class="body-small mt-10px" [innerHTML]="subTitle | translate"></div>
    }

    <!-- Handle subscribe/unsubscribe buttons -->
    @if (showButtons) {
        <div>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </div>
    }

    <!-- Handle easy account and digital post -->
    @if (isEasyAccountOrDigitalPost) {
        <!-- Show subscribe button that toggels consent/cpr UI -->
        @if (showButtons) {
            @if (!isSignedUp && !toggleConsentUi) {
                <ng-container class="flex justify-between">
                    <app-evida-button class="butto mt-30px" type="primary" (clicked)="toggleUi()"
                        >{{ subscribeButton | translate }}
                    </app-evida-button>
                </ng-container>
            }
        }
        <!-- Show consent and cpr UI -->
        @if (toggleConsentUi) {
            @if (showConsent) {
                <app-consent
                    [consentLabel]="consentLabel"
                    [birthDate]="birthDate"
                    (consentAccepted)="onConsentAccepted($event)"
                >
                </app-consent>
            }
            @if (!showConsent) {
                <div class="flex justify-between mt-30px">
                    @if (isSignedUp) {
                        <div class="subscribed flex">
                            <mat-icon svgIcon="evida_registered" inline="true"></mat-icon>
                            <span
                                class="body-copy ml-10px"
                                [translate]="'userProfile.paymentDetails.subscribed'"
                            ></span>
                        </div>
                    }
                    @if (subscribeButton && !isSignedUp) {
                        <app-evida-button class="button" type="primary" (clicked)="subscribe.emit()"
                            >{{ subscribeButton | translate }}
                        </app-evida-button>
                    }
                    @if (unsubscribeButton && isSignedUp && allowUnsubscribe) {
                        <app-evida-button class="button" type="secondary" (clicked)="unsubscribe.emit()">
                            {{ unsubscribeButton | translate }}
                        </app-evida-button>
                    }
                </div>
            }
        }
    }
</div>

<!-- Subscribed/unsubscribed buttons -->
<ng-template #buttons>
    @if (!showConsent) {
        <div class="flex justify-between mt-30px">
            @if (isSignedUp) {
                <div class="subscribed flex">
                    <mat-icon svgIcon="evida_registered" inline="true"></mat-icon>
                    <span class="body-copy ml-10px" [translate]="'userProfile.paymentDetails.subscribed'"></span>
                </div>
            }
            @if (subscribeButton && !isSignedUp) {
                <app-evida-button class="button" type="primary" (clicked)="subscribe.emit()">
                    {{ subscribeButton | translate }}
                </app-evida-button>
            }
            <!-- AllowUnsubscribe can be used until EG has a working API for disable -->
            @if (unsubscribeButton && isSignedUp && allowUnsubscribe) {
                <app-evida-button class="button" type="secondary" (clicked)="unsubscribe.emit()">
                    {{ unsubscribeButton | translate }}
                </app-evida-button>
            }
        </div>
    }
</ng-template>
